import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface FeaturesListProps {
  features: string[];
}

export function FeaturesList({ features }: FeaturesListProps) {
  if (!features || features.length === 0) return null;

  return (
    <Box 
      component="ul" 
      sx={{ 
        textAlign: 'left', 
        pl: 0, 
        mb: 2, 
        mt: 0,
        listStyle: 'none'
      }}
    >
      {features.map((feature, index) => (
        <Box 
          key={index} 
          component="li"
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            mb: 1
          }}
        >
          <CheckCircleIcon 
            sx={{ 
              color: 'secondary.main',
              fontSize: '1rem',
              mr: 1,
              mt: 0.25,
              flexShrink: 0
            }} 
          />
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ 
              fontSize: '0.875rem',
              fontWeight: 400,
              flex: 1
            }}
          >
            {feature}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

